import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  padding: var(--space-600);
  border-radius: var(--radius-brand);
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
`

export const Title = styled.h3`
  margin: 0;
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: var(--line-height-tight);
  display: flex;
  align-items: center;
  gap: var(--space-200);
`

export const Description = styled.p`
  margin: 0;
  font-size: var(--font-size-300);
  color: var(--text-secondary);
  line-height: 1.6;
`

export const SyncSection = styled.div`
  display: flex;
`

export const Footer = styled.div`
  padding-top: var(--space-300);
  border-top: 1px solid var(--color-border-secondary);
  font-size: var(--font-size-300);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
`

export const SyncedDescription = styled.p`
  font-size: var(--font-size-400);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
`

export const BlockSyncMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`
